function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.0789 6.17108C10.8509 5.943 10.4822 5.943 10.2541 6.17108L6.58319 9.842L6.58319 0.750163C6.58319 0.428162 6.32185 0.166829 5.99985 0.166829C5.67785 0.166829 5.41652 0.428162 5.41652 0.750163L5.41652 9.842L1.7456 6.17108C1.51752 5.943 1.14885 5.943 0.92077 6.17108C0.692687 6.39916 0.692687 6.76783 0.92077 6.99591L5.58744 11.6626C5.70119 11.7763 5.85052 11.8335 5.99985 11.8335C6.14919 11.8335 6.29852 11.7763 6.41227 11.6626L11.0789 6.99591C11.307 6.76783 11.307 6.39916 11.0789 6.17108Z",
  fill: "#737376"
});
function SvgKeyDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyDown);
export default __webpack_public_path__ + "static/media/key_down.17ee22da.svg";
export { ForwardRef as ReactComponent };